import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import matrimonyInstance from "../utils/axios";
import {
	formatPhoneNumber,
	getDataFromJwt,
	replaceIdInUrl,
	toastMaker,
} from "../utils/utility";
import {
	CREATE_USER,
	JOIN_BAT,
	UPDATE_ACCOUNT,
	VIEW_ACCOUNT_ADMIN,
} from "../API_LIST";

const accountData = {
	email: "",
	first_name: "",
	middle_name: "",
	last_name: "",
	gotram: "",
	phone_number: "",
	occupation: "",
	address_1: "",
	address_2: "",
	password: "",
};

const spouseData = {
	first_name: "",
	middle_name: "",
	last_name: "",
	gotram: "",
	occupation: "",
	email: "",
	relationship_id: 8,
};

const childData = {
	first_name: "",
	last_name: "",
	occupation: "",
	relationship_id: "",
};

const MyAccount = () => {
	const navigate = useNavigate();

	const [batAccountData, setBatAccountData] = useState(accountData);
	const [batSpouseData, setBatSpouseData] = useState(spouseData);
	const [batChildData, setBatChildData] = useState([childData]);
	const [isEdit, setIsEdit] = useState(false);

	const [confirmPassword, setIsConfirmPassword] = useState("");
	const [isTerms, setIsTerms] = useState(false);
	const [isRequired, setIsRequired] = useState(false);
	const [loading, setLoading] = useState(false);

	const [isVisiblePassword, setIsVisiblePassword] = useState(false);
	const [isConfirmVisible, setIsConfirmVisible] = useState(false);
	const [isRegisterPage, setIsRegisterPage] = useState(true);
	const userRole = getDataFromJwt("role");

	const handleChangeBatAccountData = (e) => {
		const { name, value, pattern } = e.target;
		let formattedValue = value;

		if (pattern && value) {
			let regex = new RegExp(pattern);
			let result = regex.test(value);
			if (!result) return;
		}
		// if (name === "phone_number") {
		// 	formattedValue = formatPhoneNumber(value);
		// }

		setBatAccountData((prev) => ({
			...prev,
			[name]: formattedValue,
		}));
	};

	const handleChangeBatSpouseData = (e) => {
		const { name, value, pattern } = e.target;
		let formattedValue = value;

		if (pattern && value) {
			let regex = new RegExp(pattern);
			let result = regex.test(value);
			if (!result) return;
		}
		setBatSpouseData((prev) => {
			return { ...prev, [e.target.name]: e.target.value };
		});
	};
	useEffect(() => {
		let id = getDataFromJwt("id");
		let url = replaceIdInUrl(VIEW_ACCOUNT_ADMIN, id);
		matrimonyInstance.get(url).then((response) => {
			let objectIs = response.data;
			let familyData = response.data.batFamily;
			let spouseData = familyData?.filter((data) => data.relationship_id === 8);
			let childrensData = familyData?.filter(
				(data) => data.relationship_id !== 8,
			);
			if (spouseData?.length) setBatSpouseData(spouseData[0]);
			if (childrensData?.length) setBatChildData(childrensData);
			setBatAccountData(objectIs);
		});
	}, []);
	const handleChangeBatChildData = (e, index) => {
		const { value, pattern } = e.target;

		if (pattern && value) {
			let regex = new RegExp(pattern);
			let result = regex.test(value);
			if (!result) return;
		}
		const updatedChildData = batChildData.map((item, _index) => {
			if (index === _index) {
				return { ...item, [e.target.name]: e.target.value };
			}
			return item;
		});
		setBatChildData(updatedChildData);
	};

	const addChildren = () => {
		setBatChildData([...batChildData, childData]);
	};

	const removeChildren = (index) => {
		let temp = [...batChildData];
		temp.splice(index, 1);
		setBatChildData(temp);
	};
	let data = {
		batAccount: batAccountData,
		batFamily: [batSpouseData, ...batChildData],
	};

	const editUser = async (e) => {
		e.preventDefault();
		setIsRequired(true);
		let data;
		delete batAccountData["profiles"];

		if (userRole === 4) {
			batAccountData.gothram = batAccountData.gotram;
			data = batAccountData;
		} else if (userRole === 3) {
			batAccountData.gothram = batAccountData.gotram;
			batAccountData.batFamily = [batSpouseData, ...batChildData];
			data = batAccountData;
		}

		if (
			batAccountData.first_name == "" ||
			batAccountData.last_name == "" ||
			batAccountData.email == "" ||
			batAccountData.gotram == "" ||
			batAccountData.phone_number == "" ||
			batAccountData.address_1 == "" ||
			batAccountData.address_2 == ""
		) {
			return toastMaker("Missing required fields", "error");
		}

		setLoading(true);
		const url = replaceIdInUrl(UPDATE_ACCOUNT, getDataFromJwt("id"));

		matrimonyInstance
			.put(url, data)
			.then((response) => {
				toastMaker("Account details updated", "success");
				setLoading(false);
				setIsEdit(false);
			})
			.catch((error) => {
				console.log("error");
				setLoading(false);
				toastMaker(error, "Error");
			});
	};

	return (
		<React.Fragment>
			<div class="dashboard-content">
				<div class="d-flex justify-content-center">
					<div class="view-profile-card mb-25 mt-50">
						<div className="account-form">
							<div className="row row-gap-3 userclick-container mx-0">
								<form onSubmit={editUser}>
									<div className="row mb-20 mx-0">
										<div className="d-flex justify-content-between">
											<h5 className="mb-30">ACCOUNT DETAILS </h5>
											<img
												src="../../assets/images/bat-img/profile-edit.svg"
												className="profile-edit-icon cursor-pointer"
												width={20}
												onClick={() => {
													setIsEdit(!isEdit);
												}}
											/>
										</div>
										<div className="col-lg-6 col-sm-10 col-12 px-3">
											<div className="form-group">
												<div className="input-title">
													<span
														className={
															isRequired &&
															batAccountData?.first_name?.length === 0 &&
															"color-red"
														}
													>
														First Name *
													</span>
												</div>
												{isEdit ? (
													<input
														type="text"
														name="first_name"
														value={batAccountData.first_name}
														onChange={handleChangeBatAccountData}
													/>
												) : (
													<b>{batAccountData.first_name ?? "Not Available"}</b>
												)}
											</div>
										</div>
										{/* <div className="col-lg-6 col-sm-10 col-12 px-3">
								<div className="form-group">
									<div className="input-title">
										<span>Middle Name</span>
									</div>
									{isEdit ? (
										<input
											type="text"
											name="middle_name"
											value={batAccountData.middle_name}
											onChange={handleChangeBatAccountData}
										/>
									) : (
										<b>{batAccountData.middle_name ?? "Not Available"}</b>
									)}
								</div>
							</div> */}
										<div className="col-lg-6 col-sm-10 col-12 px-3">
											<div className="form-group">
												<div className="input-title">
													<span
														className={
															isRequired &&
															batAccountData?.last_name?.length === 0 &&
															"color-red"
														}
													>
														Last Name *
													</span>
												</div>
												{isEdit ? (
													<input
														type="text"
														name="last_name"
														value={batAccountData.last_name}
														onChange={handleChangeBatAccountData}
													/>
												) : (
													<b>{batAccountData.last_name ?? "Not Available"}</b>
												)}
											</div>
										</div>
										<div className="col-lg-6 col-sm-10 col-12 px-3">
											<div className="form-group">
												<div className="input-title">
													<span
														className={
															isRequired &&
															batAccountData?.gender?.length === 0 &&
															"color-red"
														}
													>
														Gender *
													</span>
												</div>
												{isEdit ? (
													<select
														className="form-select"
														name="gender"
														value={batAccountData.gender}
														onChange={handleChangeBatAccountData}
													>
														<option value="" disabled>
															Select
														</option>
														<option value="Male">Male</option>
														<option value="Female">Female</option>
													</select>
												) : (
													<b>{batAccountData.gender ?? "Not Available"}</b>
												)}
											</div>
										</div>
										<div className="col-lg-6 col-sm-10 col-12 px-3">
											<div className="form-group">
												<div className="input-title">
													<span
														className={
															isRequired &&
															batAccountData?.email?.length === 0 &&
															"color-red"
														}
													>
														Email *
													</span>
												</div>
												{isEdit ? (
													<input
														type="email"
														name="email"
														value={batAccountData.email}
														onChange={handleChangeBatAccountData}
													/>
												) : (
													<b>{batAccountData.email ?? "Not Available"}</b>
												)}
											</div>
										</div>
										<div className="col-lg-6 col-sm-10 col-12 px-3">
											<div className="form-group">
												<div className="input-title">
													<span
														className={
															isRequired &&
															batAccountData?.gothram?.length === 0 &&
															"color-red"
														}
													>
														Gotram *
													</span>
												</div>
												{isEdit ? (
													<input
														type="text"
														name="gotram"
														value={batAccountData.gotram}
														onChange={handleChangeBatAccountData}
													/>
												) : (
													<b>{batAccountData.gotram ?? "Not Available"}</b>
												)}
											</div>
										</div>
										<div className="col-lg-6 col-sm-10 col-12 px-3">
											<div className="form-group">
												<div className="input-title">
													<span
														className={
															isRequired &&
															batAccountData?.phone_number?.length === 0 &&
															"color-red"
														}
													>
														Primary Contact Phone Number *
													</span>
												</div>
												{isEdit ? (
													<input
														type="tel"
														name="phone_number"
														pattern="^\+?\d{1,15}$"
														value={batAccountData.phone_number}
														maxLength="15"
														onChange={handleChangeBatAccountData}
													/>
												) : (
													<b>
														{batAccountData.phone_number ?? "Not Available"}
													</b>
												)}
											</div>
										</div>
										{userRole === 3 ? (
											<div className="col-lg-6 col-sm-10 col-12 px-3">
												<div className="form-group">
													<div className="input-title">
														<span>Occupation</span>
													</div>
													{isEdit ? (
														<input
															type="text"
															name="occupation"
															value={batAccountData.occupation}
															onChange={handleChangeBatAccountData}
														/>
													) : (
														<b>
															{batAccountData.occupation ?? "Not Available"}
														</b>
													)}
												</div>
											</div>
										) : null}
										<div className="col-lg-6 col-sm-10 col-12 px-3">
											<div className="form-group">
												<div className="input-title">
													<span
														className={
															isRequired &&
															batAccountData?.address_1?.length === 0 &&
															"color-red"
														}
													>
														Communication Address 1*
													</span>
												</div>
												{isEdit ? (
													<input
														type="text"
														name="address_1"
														value={batAccountData.address_1}
														onChange={handleChangeBatAccountData}
													/>
												) : (
													<b>{batAccountData.address_1 ?? "Not Available"}</b>
												)}
											</div>
										</div>
										<div className="col-lg-6 col-sm-10 col-12 px-3">
											<div className="form-group">
												<div className="input-title">
													<span
														className={
															isRequired &&
															batAccountData?.address_2?.length === 0 &&
															"color-red"
														}
													>
														Communication Address 2*
													</span>
												</div>
												{isEdit ? (
													<input
														type="text"
														name="address_2"
														value={batAccountData.address_2}
														onChange={handleChangeBatAccountData}
													/>
												) : (
													<b>{batAccountData.address_1 ?? "Not Available"}</b>
												)}
											</div>
										</div>

										{userRole === 3 ? (
											<>
												<h5 className="mb-30 mt-30">SPOUSE DETAILS</h5>
												<div className="col-lg-6 col-sm-10 col-12 px-3">
													<div className="form-group">
														<div className="input-title">
															<span>Spouse First Name</span>
														</div>
														{isEdit ? (
															<input
																type="text"
																name="first_name"
																value={batSpouseData.first_name}
																onChange={handleChangeBatSpouseData}
															/>
														) : (
															<b>
																{batSpouseData.first_name ?? "Not Available"}
															</b>
														)}
													</div>
												</div>
												<div className="col-lg-6 col-sm-10 col-12 px-3">
													<div className="form-group">
														<div className="input-title">
															<span>Spouse Middle Name</span>
														</div>
														{isEdit ? (
															<input
																type="text"
																name="middle_name"
																value={batSpouseData.middle_name}
																onChange={handleChangeBatSpouseData}
															/>
														) : (
															<b>
																{batSpouseData.middle_name ?? "Not Available"}
															</b>
														)}
													</div>
												</div>
												<div className="col-lg-6 col-sm-10 col-12 px-3">
													<div className="form-group">
														<div className="input-title">
															<span>Spouse Maiden Last Name</span>
														</div>
														{isEdit ? (
															<input
																type="text"
																name="last_name"
																value={batSpouseData.last_name}
																onChange={handleChangeBatSpouseData}
															/>
														) : (
															<b>
																{batSpouseData.last_name ?? "Not Available"}
															</b>
														)}
													</div>
												</div>
												<div className="col-lg-6 col-sm-10 col-12 px-3">
													<div className="form-group">
														<div className="input-title">
															<span>Spouse Maiden Gotram</span>
														</div>
														{isEdit ? (
															<input
																type="text"
																name="gotram"
																value={batSpouseData.gotram}
																onChange={handleChangeBatSpouseData}
															/>
														) : (
															<b>{batSpouseData.gotram ?? "Not Available"}</b>
														)}
													</div>
												</div>
												<div className="col-lg-6 col-sm-10 col-12 px-3">
													<div className="form-group">
														<div className="input-title">
															<span>Spouse Email</span>
														</div>
														{isEdit ? (
															<input
																type="email"
																name="email"
																value={batSpouseData.email}
																onChange={handleChangeBatSpouseData}
															/>
														) : (
															<b>{batSpouseData.email ?? "Not Available"}</b>
														)}
													</div>
												</div>
												<div className="col-lg-6 col-sm-10 col-12 px-3">
													<div className="form-group">
														<div className="input-title">
															<span>Spouse Occupation</span>
														</div>
														{isEdit ? (
															<input
																type="occupation"
																name="occupation"
																value={batSpouseData.occupation}
																onChange={handleChangeBatSpouseData}
															/>
														) : (
															<b>
																{batSpouseData.occupation ?? "Not Available"}
															</b>
														)}
													</div>
												</div>

												{batChildData.map((item, index) => (
													<React.Fragment key={index}>
														<div className="d-flex align-items-center gap-3">
															<h5 className="mb-30 mt-30">
																#{index + 1} CHILD DETAILS
															</h5>
															{isEdit ? (
																<img
																	src="../../assets/images/bat-img/close.svg"
																	style={{ width: "20px", height: "20px" }}
																	className="cursor-pointer"
																	onClick={() => {
																		removeChildren(index);
																		console.log("index", index);
																	}}
																/>
															) : null}
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3 mb-20">
															<div className="input-title">
																<label>Relation</label>
															</div>
															{isEdit ? (
																<select
																	name="relationship_id"
																	value={batChildData[index]?.relationship_id}
																	onChange={(e) =>
																		handleChangeBatChildData(e, index)
																	}
																	className="form-select rounded-1 mt-15"
																>
																	<option value="" disabled>
																		Select
																	</option>
																	<option value="1">Son</option>
																	<option value="2">Daughter</option>
																</select>
															) : (
																<b>
																	{batChildData[index]?.relationship_id ??
																		"Not Available"}
																</b>
															)}
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span>First Name</span>
																</div>
																{isEdit ? (
																	<input
																		type="text"
																		name="first_name"
																		pattern="^[a-zA-Z ]+$"
																		value={batChildData[index]?.first_name}
																		onChange={(e) =>
																			handleChangeBatChildData(e, index)
																		}
																	/>
																) : (
																	<b>
																		{batChildData[index]?.first_name ??
																			"Not Available"}
																	</b>
																)}
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span>Middle name</span>
																</div>
																{isEdit ? (
																	<input
																		type="text"
																		name="middle_name"
																		pattern="^[a-zA-Z ]+$"
																		value={batChildData[index]?.middle_name}
																		onChange={(e) =>
																			handleChangeBatChildData(e, index)
																		}
																	/>
																) : (
																	<b>
																		{batChildData[index]?.middle_name ??
																			"Not Available"}
																	</b>
																)}
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span>Last Name</span>
																</div>
																{isEdit ? (
																	<input
																		type="text"
																		name="last_name"
																		pattern="^[a-zA-Z ]+$"
																		value={batChildData[index]?.last_name}
																		onChange={(e) =>
																			handleChangeBatChildData(e, index)
																		}
																	/>
																) : (
																	<b>
																		{batChildData[index]?.last_name ??
																			"Not Available"}
																	</b>
																)}
															</div>
														</div>

														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span>Gotram</span>
																</div>
																{isEdit ? (
																	<input
																		type="text"
																		name="gotram"
																		pattern="^[a-zA-Z ]+$"
																		value={batChildData[index]?.gotram}
																		onChange={(e) =>
																			handleChangeBatChildData(e, index)
																		}
																	/>
																) : (
																	<b>
																		{batChildData[index]?.gotram ??
																			"Not Available"}
																	</b>
																)}
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span>Email</span>
																</div>
																{isEdit ? (
																	<input
																		type="text"
																		name="email"
																		value={batChildData[index]?.email}
																		onChange={(e) =>
																			handleChangeBatChildData(e, index)
																		}
																	/>
																) : (
																	<b>
																		{batChildData[index]?.email ??
																			"Not Available"}
																	</b>
																)}
															</div>
														</div>
														<div className="col-lg-6 col-sm-10 col-12 px-3">
															<div className="form-group">
																<div className="input-title">
																	<span>Occupation</span>
																</div>
																{isEdit ? (
																	<input
																		type="text"
																		name="occupation"
																		pattern="^[a-zA-Z ]+$"
																		value={batChildData[index]?.occupation}
																		onChange={(e) =>
																			handleChangeBatChildData(e, index)
																		}
																	/>
																) : (
																	<b>
																		{batChildData[index]?.occupation ??
																			"Not Available"}
																	</b>
																)}
															</div>
														</div>
													</React.Fragment>
												))}
												{isEdit ? (
													<div
														className="mb-20 d-flex align-items-center gap-2 cursor-pointer"
														onClick={addChildren}
													>
														<img
															src="../../assets/images/bat-img/add.svg"
															style={{ width: "30px", height: "30px" }}
														/>
														<span>Add Child</span>
													</div>
												) : null}
											</>
										) : null}
									</div>
									{isEdit ? (
										<button
											type="submit"
											className="btn mt-20 mb-50 login-btn text-white"
											onClick={editUser}
										>
											Submit
										</button>
									) : null}
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default MyAccount;
